import { Box, Button, Stack, Typography } from '@mui/material'
import { observer } from 'mobx-react-lite'
import { useNavigate } from 'react-router-dom'
import { BILLING_CONSTANTS, URL_PATHS } from '@constants'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import { OvCard, PageWrapper } from '@components'

export const RegistrationCompleteView = observer(() => {
  const navigate = useNavigate()

  return (
    <PageWrapper background="primary-gradient">
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '80vh',
          padding: 2,
        }}>
        <OvCard sx={{ maxWidth: 600, width: '100%' }}>
          <Stack spacing={3} alignItems="center">
              {/* Success icon with gradient */}
              <CheckCircleOutlineIcon
                sx={{
                  fontSize: 100,
                  color: 'success.main',
                  filter: 'drop-shadow(0px 4px 8px rgba(76, 175, 80, 0.3))',
                }}
              />

              {/* Header */}
              <Typography
                variant="h3"
                align="center"
                sx={{
                  fontWeight: 700,
                  color: 'text.primary',
                }}>
                Welkom bij Outvoice PRO!
              </Typography>

              <Typography variant="body1" align="center" color="text.secondary">
                Je account is succesvol aangemaakt en je proefperiode is gestart.
              </Typography>

              {/* Trial info box with gradient border */}
              <Box
                sx={{
                  p: 2.5,
                  background: 'linear-gradient(315deg, rgba(49, 27, 146, 0.08) 0%, rgba(245, 0, 87, 0.08) 100%)',
                  borderRadius: 2,
                  border: '1px solid',
                  borderColor: 'primary.main',
                  borderStyle: 'dashed',
                  alignSelf: 'stretch',
                  textAlign: 'center',
                }}>
                <Typography
                  variant="h6"
                  gutterBottom
                  sx={{
                    fontWeight: 600,
                    color: 'primary.main',
                  }}>
                  {BILLING_CONSTANTS.MESSAGES.TRIAL_WELCOME}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {BILLING_CONSTANTS.MESSAGES.TRIAL_INFO_LONG}
                </Typography>
              </Box>

              {/* Features list */}
              <Box sx={{ alignSelf: 'stretch' }}>
                <Typography
                  variant="h4"
                  gutterBottom
                  sx={{
                    fontWeight: 700,
                    color: 'text.primary',
                    mb: 2,
                  }}>
                  Wat je nu kunt doen:
                </Typography>
                <Stack spacing={1.5}>
                  <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Box component="span" sx={{ color: 'primary.main', fontWeight: 'bold' }}>
                      ✓
                    </Box>
                    Onbeperkt facturen en offertes maken
                  </Typography>
                  <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Box component="span" sx={{ color: 'primary.main', fontWeight: 'bold' }}>
                      ✓
                    </Box>
                    E-mails versturen met je eigen templates
                  </Typography>
                  <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Box component="span" sx={{ color: 'primary.main', fontWeight: 'bold' }}>
                      ✓
                    </Box>
                    PDF branding met je eigen logo
                  </Typography>
                  <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Box component="span" sx={{ color: 'primary.main', fontWeight: 'bold' }}>
                      ✓
                    </Box>
                    KVK en BTW validatie
                  </Typography>
                  <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Box component="span" sx={{ color: 'primary.main', fontWeight: 'bold' }}>
                      ✓
                    </Box>
                    Uitgebreide analytics bekijken
                  </Typography>
                </Stack>
              </Box>

              <Typography variant="caption" color="text.secondary" align="center" sx={{ pt: 1 }}>
                {BILLING_CONSTANTS.MESSAGES.TRIAL_INFO_SHORT}
              </Typography>

              <Button
                variant="contained"
                size="large"
                fullWidth
                onClick={() => navigate(URL_PATHS.DASHBOARD)}
                sx={{ mt: 2 }}>
                Ga naar Dashboard
              </Button>
            </Stack>
        </OvCard>
      </Box>
    </PageWrapper>
  )
})
